// src/lib/transport/detector.ts
// Erkennt automatisch: Capacitor oder Browser

/**
 * Prüft, ob Capacitor verfügbar ist
 * @returns true wenn Capacitor verfügbar ist, sonst false
 */
export function isCapacitorAvailable(): boolean {
  try {
    // Prüfe, ob Capacitor global verfügbar ist
    // Capacitor wird dynamisch importiert, um Fehler in Browser-Umgebung zu vermeiden
    if (typeof window !== "undefined") {
      const win = window as {
        Capacitor?: { isNativePlatform?: () => boolean };
      };
      if (win.Capacitor) {
        // Prüfe, ob es wirklich eine native Platform ist
        if (win.Capacitor.isNativePlatform) {
          return win.Capacitor.isNativePlatform();
        }
        return true; // Capacitor vorhanden, auch wenn isNativePlatform nicht verfügbar
      }
    }
    // Fallback: Prüfe auf typische Capacitor-Umgebungsvariablen
    if (typeof navigator !== "undefined" && navigator.userAgent) {
      // Capacitor Apps haben typischerweise "Capacitor" im User-Agent
      return navigator.userAgent.includes("Capacitor");
    }
    return false;
  } catch {
    return false;
  }
}

/**
 * Prüft, ob wir in einer nativen Umgebung sind (Capacitor)
 * @returns true wenn native, sonst false (Browser/PWA)
 */
export function isNativePlatform(): boolean {
  return isCapacitorAvailable();
}

/**
 * Prüft, ob wir in einer Browser/PWA-Umgebung sind
 * @returns true wenn Browser/PWA, sonst false (Native)
 */
export function isPwaPlatform(): boolean {
  return !isCapacitorAvailable();
}

/**
 * Gibt die aktuelle Platform zurück
 * @returns "native" für Capacitor, "pwa" für Browser
 */
export function getPlatform(): "native" | "pwa" {
  return isCapacitorAvailable() ? "native" : "pwa";
}
